import Component from '../core/Component'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const STATES = {
    READY: 'is-ready'
}

export default class DuoGallery extends Component {
    constructor(element, options) {
        super(element, options = {
            itemsPerPage: 2
        })

        this.ref = {
            slider: null,
            dotContainer: null,
            next: null,
            prev: null,
            items: [],
        }
        this.ref.boxes = [...document.querySelectorAll('[data-ref="box"]',this.element)]

        this.enquireMediumUpHandler = {
            match: () => {
                this.destroyMobileFlickity()
                this.createDesktopSlider()
            }
        }

        this.enquireSmallWideMaxHandler = {
            match: () => {
                this.destroyDesktopSlider()
                this.createMobileFlickity()
            }
        }

        this.mobileFlickity = null
        this.pageIndex = null
    }

    prepare() {
        this.ref.next.addEventListener('click', this.handleNextClick)
        this.ref.prev.addEventListener('click', this.handlePrevClick)

        enquire.register(queries.mediumUp, this.enquireMediumUpHandler)
        enquire.register(queries.smallWideMax, this.enquireSmallWideMaxHandler)
        this.element.classList.add(STATES.READY)
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireMediumUpHandler)
        enquire.unregister(queries.smallWideMax, this.enquireSmallWideMaxHandler)

        this.destroyDesktopSlider()
        this.destroyMobileFlickity()
    }

    handlePrevClick = () => {
        if (this.mobileFlickity) {
            this.mobileFlickity.previous()
        } else {
            this.selectPreviousPage()
        }
    }

    handleNextClick = () => {
        if (this.mobileFlickity) {
            this.mobileFlickity.next()
        } else {
            this.selectNextPage()
        }
    }




    //MOBILE VERZE
    createMobileFlickity() {
        if (this.mobileFlickity) {
            return
        }

        this.mobileFlickity = new Flickity(this.ref.slider,{
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            groupCells: '100%'
        })
    }

    destroyMobileFlickity() {
        if (this.mobileFlickity) {
            this.mobileFlickity.destroy()
            this.mobileFlickity = null
        }
    }


    //DESKTOP VERZE
    handleDotsClick = event => {
        const dot = event.target
        const index = [...this.ref.dotContainer.children].indexOf(dot)
        if (!~index) {
            return
        }
        this.selectPage(index)
    }

    createDesktopSlider() {
        if (this.isDesktopSlider) {
            return
        }

        this.pageIndex = null
        this.createDots()
        this.ref.dotContainer.addEventListener('click', this.handleDotsClick)

        const boxCount = this.ref.boxes.length
        this.ref.items.forEach((item,index) => {
            this.ref.boxes[index % boxCount].appendChild(item)
        })

        this.selectPage(0)

        this.isDesktopSlider = true
    }

    destroyDesktopSlider() {
        this.ref.dotContainer.removeEventListener('click', this.handleDotsClick)
        this.ref.items.forEach(item => {
            this.ref.slider.appendChild(item)
        })
        this.isDesktopSlider = false
    }

    createDots() {
        let dots = ''
        const count = this.ref.items.length / this.options.itemsPerPage

        if (count <= 1) {
            return
        }

        for (let index = 0; index < count; index++) {
            dots += `<span class="dot ${this.pageIndex === index ? 'is-selected':''}"></span>`
        }

        this.ref.dotContainer.innerHTML = dots
    }

    checkPrevNext() {
        const count = Math.ceil(this.ref.items.length / this.options.itemsPerPage)

        if (this.pageIndex !== count - 1 && count !== 1) {
            this.ref.next.classList.add('is-visible')
        } else {
            this.ref.next.classList.remove('is-visible')
        }

        if (this.pageIndex !== 0) {
            this.ref.prev.classList.add('is-visible')
        } else {
            this.ref.prev.classList.remove('is-visible')
        }
    }

    checkDots() {
        const dots = [...this.ref.dotContainer.children]
        dots.forEach(dot => dot.classList.remove('is-selected'))
        const currentDot = this.ref.dotContainer.children[this.pageIndex]
        if (currentDot) {
            currentDot.classList.add('is-selected')
        }
    }

    selectPreviousPage() {
        const pageIndex = Math.max(this.pageIndex - 1, 0)
        this.selectPage(pageIndex)
    }

    selectNextPage() {
        const pageIndex = Math.ceil(Math.min(this.pageIndex + 1, this.ref.items.length / this.options.itemsPerPage - 1))
        this.selectPage(pageIndex)
    }

    selectPage(pageIndex) {
        if (pageIndex === this.pageIndex) {
            return
        }

        this.pageIndex = pageIndex

        const fromIndex = pageIndex * this.options.itemsPerPage
        const toIndex = fromIndex + this.options.itemsPerPage - 1
        this.ref.items.forEach((item,index) => {
            item.classList.remove('is-next')
            item.classList.remove('is-prev')

            if (index < fromIndex) {
                item.classList.add('is-prev')
            }
            if (index > toIndex) {
                item.classList.add('is-next')
            }
        })

        this.checkDots()
        this.checkPrevNext()
    }
}


// WEBPACK FOOTER //
// ./components/DuoGallery.js